import { localStorageAvailable } from '@utils/localStorage';
import { TABS_CONSTANT, PROGRAM_LANDING_PAGE } from './constants';

const getRefsMap = ({
  overViewRef,
  curriculumRef,
  caseStudiesRef,
  facultyRef,
  faqsRef,
  certificationRef,
  successStoriesRef,
  courseFeesRef,
  applicationProcessRef
}) => ({
  [TABS_CONSTANT.OVERVIEW]: overViewRef,
  [TABS_CONSTANT.CURRICULUM]: curriculumRef,
  [TABS_CONSTANT.CASE_STUDIES]: caseStudiesRef,
  [TABS_CONSTANT.FACULTIES]: facultyRef,
  [TABS_CONSTANT.FAQs]: faqsRef,
  [TABS_CONSTANT.CERTIFICATION]: certificationRef,
  [TABS_CONSTANT.SUCCESS_STORIES]: successStoriesRef,
  [TABS_CONSTANT.COURSE_FEE]: courseFeesRef,
  [TABS_CONSTANT.APPLICATION_PROCESS]: applicationProcessRef
});
export default getRefsMap;

export const getProgramLandingPage = () => {
  if (localStorageAvailable()) {
    let programLandingPageData = localStorage.getItem(PROGRAM_LANDING_PAGE);
    if (programLandingPageData === null) programLandingPageData = [];
    else {
      programLandingPageData = JSON.parse(programLandingPageData);
    }
    return programLandingPageData;
  }
  return [];
};
